/** The blanks naming a party the notice is served on, by recipient role, as the API's `recipientFields` fills them. */
export const recipientFields = { contractor: 'contractor', lender: 'lender', surety: 'surety', ownerDesignee: 'owner-designee',
  additionalNoticeDesignee: 'additional-notice-designee', feeSimpleTitleholder: 'fee-simple-titleholder', publicAuthority: 'public-authority' };
